import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Logout from "@mui/icons-material/Logout";
import { FiUser } from "react-icons/fi";
import ModalLogout from "../modals/ModalLogout";
import coverimg from "../../components/images/cover.png";
import { IoMdNotifications } from "react-icons/io";
import { Avatar, Box, Popover } from "@mui/material";
import { IoClose } from "react-icons/io5";
import { MdDeleteOutline } from "react-icons/md";
import "./Navbar.css";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const Navbar = () => {
  const User = useSelector((state: RootState) => state.User);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [logoutmodel, setLogoutModel] = useState(false);
  const [notificationAnchorEl, setNotificationAnchorEl] =
    useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const open_notification = Boolean(notificationAnchorEl);

  const handleNotificationClick = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationAnchorEl(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setNotificationAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setLogoutModel(true);
  };

  return (
    <>
      <nav className="bg-white dark:bg-gray-900 fixed w-full z-20 top-0 start-0 border-b border-gray-200 dark:border-gray-600 shadow-md">
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
          <span className="flex items-center space-x-3 rtl:space-x-reverse">
            <Link to="/">
              <div className="logo-container">
                <span className="logo self-center text-2xl whitespace-nowrap dark:text-white">
                  Comicfy
                </span>
              </div>
            </Link>
          </span>
          <div className="w-[102px] flex justify-end md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse">
            <span
              className="relative notification-icon mr-2"
              onClick={handleNotificationClick}
            >
              {/* <span className='bg-red-500 text-white rounded-full absolute top-0 right-0 flex items-center justify-center text-[10px] w-5 h-5'>
              2
            </span> */}
              <IoMdNotifications size={22} />
            </span>
            <Popover
              disableScrollLock={true}
              open={open_notification}
              anchorEl={notificationAnchorEl}
              onClose={handleNotificationClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  width: "300px",
                  borderRadius: "10px",
                },
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  mt: "10px",
                  "&::before": {
                    backgroundColor: "white",
                    content: '""',
                    display: "block",
                    position: "absolute",
                    width: 12,
                    height: 12,
                    top: -6,
                    transform: "rotate(45deg)",
                    left: "calc(50% - 6px)",
                  },
                }}
              />
              <div>
                <div className="px-3 flex justify-between items-center border-b shadow-sm pb-3">
                  <span className="text-[20px] font-semibold">
                    Notification
                  </span>

                  <div>
                    <span
                      onClick={handleNotificationClose}
                      className="cursor-pointer notification-icon !h-[30px] w-[30px]"
                    >
                      <IoClose fill="#000" size={20} />
                    </span>
                  </div>
                </div>

                <div className="nav-notification">
                  {/* <div className='notification read flex justify-between items-start p-3'>
                  <div className='flex items-start'>
                    <span><div className='h-10 w-10 bg-blue-500 rounded-full'></div></span>
                    <div className='flex flex-col px-2'>
                      <span>John liked your post</span>
                      <span className='text-sm text-[#888]'>15 mins ago</span>
                    </div>
                  </div>
                  <span><div className='cursor-pointer notification-icon !h-[30px] w-[30px] text-red-600'>
                    <MdDeleteOutline size={20} />
                  </div></span>
                </div>
                <div className='notification flex justify-between items-start p-3'>
                  <div className='flex items-start'>
                    <span><div className='h-10 w-10 bg-blue-500 rounded-full'></div></span>
                    <div className='flex flex-col px-2'>
                      <span>Anna commented on your story 45 mins ago 45 mins ago Anna commented on your story Anna commented on your story</span>
                      <span className='text-sm text-[#888]'>15 mins ago</span>
                    </div>
                  </div>
                  <span><div className='cursor-pointer notification-icon !h-[30px] w-[30px] text-red-600'>
                    <MdDeleteOutline size={20} />
                  </div></span>
                </div> */}
                </div>
              </div>
            </Popover>
            <Avatar
              onClick={handleClick}
              src={User?.user?.profileImage || undefined}
              alt={User?.user?.name || "User"}
              sx={{ width: 40, height: 40, cursor: "pointer" }}
            />
            <Menu
              disableScrollLock={true}
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 0px 1px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  borderRadius: "10px",
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&::before": {
                    borderRadius: "20px",
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "#CEDAFF",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <NavLink to="/profile">
                <MenuItem>
                  <ListItemIcon>
                    <FiUser size={25} style={{ color: "#007BFF" }} />
                  </ListItemIcon>
                  My Profile&nbsp;&nbsp;&nbsp;
                </MenuItem>
              </NavLink>
              <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                  <Logout fontSize="medium" sx={{ color: "#007BFF" }} />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </div>
          <div
            className="items-center justify-between hidden w-full lg:flex lg:w-auto lg:order-1"
            id="navbar-sticky"
          >
            <ul className="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
              <li>
                <NavLink to="/" className="navitem">
                  Dashboard
                </NavLink>
              </li>
              <li>
                <NavLink to="/create" className="navitem">
                  Create
                </NavLink>
              </li>
              <li>
                <NavLink to="/mystories" className="navitem">
                  My Creations
                </NavLink>
              </li>
              <li>
                <NavLink to="/lesson-plan" className="navitem">
                  Lesson Plan
                </NavLink>
                <span className="bg-blue-500 text-white px-2 py-1 rounded-full text-xs ml-2">
                  Coming Soon!
                </span>
              </li>
              <li>
                <NavLink to="/myplans" className="navitem">
                  My Plans
                </NavLink>
              </li>
              <li>
                <NavLink to="/help" className="navitem">
                  Support
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <ModalLogout logoutmodel={logoutmodel} setLogoutModel={setLogoutModel} />
    </>
  );
};

export default Navbar;
